module.exports = __webpack_public_path__ + "media/images/pc/brands/eight/store_nagoya_ekimae-35864cd0de4cd3f9200e3b4c81086eb5.jpg";